module.exports = __webpack_public_path__ + "static/media/what-is-air-pollution.518423f0.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/media/help-and-guides/what-is-air-pollution.jpeg
// module id = 785
// module chunks = 0